import groupBy from 'lodash/groupBy';
import sum from 'lodash/sum';
import { getHoverColor } from 'chart.js/helpers';
import { palette } from 'theme/palette';
import { Plugin } from 'chart.js';

const HEIGHT_OF_ZERO_USAGE_INTERIM = 16;
const BG_COLOR_OF_ZERO_USAGE_INTERIM = palette.red['200'];
const BORDER_COLOR_OF_ZERO_USAGE_INTERIM = palette.red['500'];

export const createZeroUsageInterimRenderer = (_datasets: any): Plugin => ({
  id: 'zeroUsageInterims',
  beforeEvent(_chart, args, _options) {
    const event = args.event;
    if (event.type === 'mousemove' && event.x) {
      // @ts-expect-error -- Plugin type doesn't allow extra properties
      this.mouseXPosition = event.x;
    }

    if (event.type === 'mouseout') {
      // @ts-expect-error -- Plugin type doesn't allow extra properties
      this.mouseXPosition = null;
    }
  },

  afterDraw(chart, _args, _options) {
    const {
      ctx,
      chartArea: { bottom },
      scales,
    } = chart;

    const groupedUsageByInterim = Object.values(
      groupBy(chart.data.datasets[0].data, (value) => {
        // @ts-expect-error -- now plugin is typed, shows value may be null
        return value.dataIndex;
      }),
    );

    const interimsWithZeroUseage = groupedUsageByInterim.filter((value) => {
      const [input, output] = value;
      // @ts-expect-error -- now plugin is typed, shows input and output may be null
      return sum(input.y) + sum(output.y) === 0;
    });

    // @ts-expect-error -- now plugin is typed, shows value may be null
    const emptyInterimsXRangeToRender = interimsWithZeroUseage.map((value) => value[0].x);

    ctx.save();

    emptyInterimsXRangeToRender.forEach(([from, to]) => {
      const xBegin = scales.x.getPixelForValue(from);
      const xEnd = scales.x.getPixelForValue(to);
      const yBegin = bottom - HEIGHT_OF_ZERO_USAGE_INTERIM;

      const width = xEnd - xBegin;

      ctx.fillStyle = BG_COLOR_OF_ZERO_USAGE_INTERIM;
      ctx.strokeStyle = BORDER_COLOR_OF_ZERO_USAGE_INTERIM;
      // @ts-expect-error -- Plugin type doesn't allow extra properties
      if (this.mouseXPosition > xBegin && this.mouseXPosition < xEnd) {
        ctx.fillStyle = getHoverColor(BG_COLOR_OF_ZERO_USAGE_INTERIM);
      }

      ctx.fillRect(xBegin, yBegin, width, HEIGHT_OF_ZERO_USAGE_INTERIM);
      ctx.strokeRect(xBegin, yBegin, width, HEIGHT_OF_ZERO_USAGE_INTERIM);
    });

    ctx.restore();
  },
});
